/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { BehaviorSubject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LmsLoggerService } from './lms-logger.service';
import { MessageDetails } from '../model/message-details.model';
import { UtilService } from './util.service';

/**
 * @export
 * @class MessageHandlerService
 */
@Injectable()
export class MessageHandlerService {

    messageObservable: Observable<MessageDetails>;
    private messagesBehaviourSubject: BehaviorSubject<MessageDetails>;

    /**
     * Creates an instance of MessageHandlerService.
     * @param {UtilService} utilService
     * @param {LmsLoggerService} lmsLoggerService
     * @memberOf MessageHandlerService
     */
    constructor(private utilService: UtilService, private lmsLoggerService: LmsLoggerService) {
        this.messagesBehaviourSubject = <BehaviorSubject<MessageDetails>>new BehaviorSubject({});
        this.messageObservable = this.messagesBehaviourSubject.asObservable();
    }

    /**
     * this method is used to handle the messages which are
     * send by Components in case any error occurs
     * @param {MessageDetails} message
     * @memberOf MessageHandlerService
     */
    handleMessage(message: MessageDetails) {
        if (message.level === 'info') {
            this.lmsLoggerService.logInfo('MessageHandlerService => handleMessage()', message.message);
        } else if (message.level === 'warn') {
            this.lmsLoggerService.logWarn('MessageHandlerService => handleMessage()', message.message);
        } else if (message.level === 'error' || message.level === 'fatal') {
            this.lmsLoggerService.logError('MessageHandlerService => handleMessage()', message.message);
        }

        this.messagesBehaviourSubject.next(this.utilService.deepClone(message));
    }
}
